import type { TrigKey } from './keys';

export const te: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'గణితం · త్రికోణమితి',
  'panel.experiment': 'ప్రయోగం',
  'panel.params': 'పారామితులు',
  'panel.scene': 'ప్రయోగాన్ని ఎంచుకోండి',
  'experiment.right-triangle.label': 'లంబకోణ త్రిభుజం',
  'experiment.unit-circle.label': 'యూనిట్ వృత్తం',
  'experiment.wave-studio.label': 'తరంగ స్టూడియో',
  'experiment.identity-playground.label': 'అనన్యతలు',
  'experiment.triangle-solver.label': 'త్రిభుజ పరిష్కర్త',
  'experiment.circular-polar.label': 'వృత్తీయ & ధ్రువ',
  'hint.line1': 'బిందువులను లాగండి, స్లైడర్‌లను కదలించండి.',
  'hint.line2': 'విద్యా విషయం రేఖాగణితంలో ఉంటుంది, పాఠ్యంలో కాదు.',
  'rt.angle.a': 'కోణం A',
  'rt.angle.b': 'కోణం B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'రేడియన్',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° కు స్నాప్',
  'uc.units': 'యూనిట్లు',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC చూపు',
  'uc.snap.common': 'సాధారణ కోణాలకు స్నాప్',
  'uc.angle.value': '∠',
  'uc.units.deg': 'డిగ్రీ',
  'uc.units.rad': 'రాడ్',
  'uc.units.both': 'డిగ్రీ+రాడ్',
  'ws.fn': 'ఫంక్షన్',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — విస్తీర్ణం',
  'ws.frequency': 'B — పౌనఃపున్యం',
  'ws.phase': 'C — ఫేజ్ షిఫ్ట్',
  'ws.shift': 'D — నిలువు షిఫ్ట్',
  'ws.rform.toggle': 'R-రూపం',
  'ws.rform.a': 'a (sin గుణకం)',
  'ws.rform.b': 'b (cos గుణకం)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'రీసెట్',
  'ws.base': 'ఆధార వక్రం',
  'ip.id.pythagorean': 'పైథాగరస్',
  'ip.id.reciprocal': 'వ్యుత్క్రమం',
  'ip.id.quotient': 'భాగఫలం',
  'ip.id.sum': 'మొత్తం',
  'ip.id.difference': 'తేడా',
  'ip.id.double': 'రెండింతలు',
  'ip.id.half': 'సగం',
  'ip.play': 'ఆడించు',
  'ip.pause': 'విరామం',
  'ip.step': 'అడుగు',
  'ip.reset': 'రీసెట్',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2లో — ఈ నిరూపణకు మరింత విస్తృత నిర్మాణం అవసరం.',
  'ts.area': 'వైశాల్యం',
  'ts.sineRule': 'సైన్ నియమం',
  'ts.cosineRule': 'కొసైన్ నియమం',
  'ts.ambiguous.toggle': 'అస్పష్టత దగ్గర ఘోస్ట్',
  'ts.reset': 'సమభుజికి రీసెట్',
  'ts.snap.integers': 'పూర్ణాంకాలకు స్నాప్',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'భుజాలు',
  'ts.section.angles': 'కోణాలు',
  'ts.section.sineRule': 'సైన్ నియమం',
  'ts.section.cosineRule': 'కొసైన్ నియమం',
  'ts.section.area': 'వైశాల్యం',
  'cp.omega': 'కోణీయ వేగం',
  'cp.plot.y': 'y ప్లాట్ (sin)',
  'cp.plot.x': 'x ప్లాట్ (cos)',
  'cp.polar.label': 'ధ్రువ చిత్రం',
  'cp.polar.circle': 'వృత్తం (r = 1)',
  'cp.polar.rose': 'గులాబి (r = sin 3θ)',
  'cp.polar.cardioid': 'హృదయాకృతి (r = 1 + cos θ)',
  'cp.polar.limacon': 'లిమాసన్ (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'చిన్న కోణ సన్నికటతం (sin x ≈ x)',
  'cp.play': 'ఆడించు',
  'cp.pause': 'విరామం',
  'cp.reset': 'రీసెట్',
  'cp.step': 'అడుగు π/12',
};
